<template>
  <div> confirm phase</div>
</template>

<script>
  export default {
    name: "confirm",
    props: {
      device: {
        type: Object,
        required: false,
      },
      sensors: {
        type: Array,
        required: false
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/project/components/confirm.vue